module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(!_vm.deleteArea) ? _c('div', [_c('div', {
    staticClass: "pt-3 pb-5 text-xs-center"
  }, [_vm._v("\n        On dirait que vous souhaitez aider la communauté à en savoir plus sur cette aire ? Vous êtes au bon endroit.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pb-3"
  }, [_vm._v("\n        La nuit l'aire est :\n      ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.openAtNight),
      callback: function($$v) {
        _vm.openAtNight = $$v
      },
      expression: "openAtNight"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "ouverte",
      "value": "true"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "fermée",
      "value": "false"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "secondary",
      "label": "on ne sait pas",
      "value": "undefined"
    }
  })], 1), _vm._v("\n      L'aire est :\n      "), _c('v-radio-group', {
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.freeArea),
      callback: function($$v) {
        _vm.freeArea = $$v
      },
      expression: "freeArea"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "gratuite",
      "value": "true"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "payante",
      "value": "false"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "secondary",
      "label": "on ne sait pas",
      "value": "undefined"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Équipement",
      "items": _vm.equipmentsDict,
      "multiple": "",
      "chips": "",
      "color": "primary",
      "hint": "Quels sont les équipements présents ?",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.equipments),
      callback: function($$v) {
        _vm.equipments = $$v
      },
      expression: "equipments"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pt-5",
    attrs: {
      "color": "error",
      "label": "Cette aire devrait être supprimée de la carte"
    },
    model: {
      value: (_vm.deleteArea),
      callback: function($$v) {
        _vm.deleteArea = $$v
      },
      expression: "deleteArea"
    }
  }), _vm._v(" "), (_vm.deleteArea) ? _c('v-textarea', {
    attrs: {
      "color": "error",
      "box": "",
      "label": "Parce que...",
      "hint": "Expliquer en quelques mots pourquoi"
    },
    model: {
      value: (_vm.deleteReason),
      callback: function($$v) {
        _vm.deleteReason = $$v
      },
      expression: "deleteReason"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pt-3 text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.authenticateAndCallback(_vm.saveAreaInfos)
      }
    }
  }, [_vm._v("Enregistrer")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e14a06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditArea.vue
// module id = 451
// module chunks = 1